<template>
	<div class="data-wrap">
		<!-- <button type="button" @click="temp">temp</button> -->
		<div class="content-wrap" style="padding-bottom: 60px;">
			<!-- 搜索条件 -->
			<!-- <el-row class="search-wrap" :gutter="20">
				<el-col :sm="24" :md="6" class="u-m-t-44">
					<div class="u-flex">
						<span class="c3 fw">年份：</span>
						<el-select multiple clearable size='mini' v-model="query.years" placeholder="请选择"
							class="u-flex-1" @change='yearSelectChange2' ref="select_year2">
							<el-option v-for="item in optionsYears" :key="item" :value="item">
							</el-option>
						</el-select>
					</div>
				</el-col>
				<el-col :sm="24" :md="6" class="u-m-t-44">
					<div class="u-flex u-col-top">
						<span class="c3 fw" style="margin-top: 4px;">地区：</span>
						<el-cascader size='mini' v-model="query.province_codes" :options="area_list2" :props="props"
							clearable class="u-flex-1" :show-all-levels="false" collapse-tags>
						</el-cascader>
					</div>
				</el-col>
				<el-col :sm="24" :md="6" class="u-m-t-44">
					<div class="u-flex">
						<span class="c3 fw">基本信息：</span>
						<el-select clearable multiple size='mini' v-model="query.index_2nd" placeholder="请选择"
							class="u-flex-1" @change='infoSelectChange2' ref="select_info2">
							<el-option v-for="item in optionsInfo2" :key="item.second_index_standard"
								:value="item.second_index_standard">
							</el-option>
						</el-select>
					</div>
				</el-col>
				<el-col :sm="24" :md="6" class="u-m-t-44">
					<div class="u-flex">
						<span class="c3 fw">申请状态：</span>
						<el-select clearable size='mini' v-model="query.approve_status" placeholder="请选择"
							class="u-flex-1">
							<el-option v-for="item in optionsStatus" :key="item.value" :label="item.label"
								:value="item.value">
							</el-option>
						</el-select>
					</div>
				</el-col>
			</el-row> -->
			<!-- 操作按钮 -->
			<!-- <div class="u-flex u-row-right" style="margin-top: 24px;">
				<el-button size="mini" class="bg1" @click='search'>搜索</el-button>
				<el-button size="mini" class="bg2" @click="dialogVisible=true">数据申请</el-button>
			</div> -->
			<!-- pc -->
			<div class="u-flex u-row-between hidden-sm-and-down" style="margin-top: 24px;">
				<span class="cm u-font-18 fw">数据申请记录</span>
				<div>
					<el-button size="mini" type="success" @click="dialogVisibleQuestion=true" style="width: auto;">
						下载调查问卷</el-button>
					<el-button size="mini" type="primary" :disabled="!approveFile"
						@click="export_qusetion(approveFile,'数据申请模板')" style="width: auto;">下载数据申请模板</el-button>
					<el-button size="mini" class="bg2" @click="openStandard">数据申请</el-button>
				</div>
			</div>
			<!-- 移动端 -->
			<div class="hidden-md-and-up" style="margin-top: 10px;">
				<div class="cm u-font-18 fw">数据申请记录</div>
				<div>
					<el-button size="mini" type="success" @click="dialogVisibleQuestion=true" style="width: auto;">
						下载调查问卷</el-button>
					<el-button size="mini" type="primary" :disabled="!approveFile"
						@click="export_qusetion(approveFile,'数据申请模板')" style="width: auto;">下载数据申请模板</el-button>
					<el-button size="mini" class="bg2" @click="openStandard">数据申请</el-button>
				</div>
			</div>
			<!-- 表格  审批不通过有图表可以点击看原因 审批通过可以点进去看详情和导出-->
			<el-table :data="tableData" style="width: 100%;margin-top: 24px;" :row-class-name='row_class_func'
				@row-click='row_click' v-loading="loading">
				<el-table-column align='center' min-width='80' prop="data_type_name" label="数据类型"
					:show-overflow-tooltip='true'>
				</el-table-column>
				<el-table-column align='center' min-width='120' prop="province_str" label="地区"
					:show-overflow-tooltip='true'>
				</el-table-column>
				<el-table-column align='center' min-width='160' prop="info_str" label="基本信息"
					:show-overflow-tooltip='true'>
				</el-table-column>
				<el-table-column align='center' min-width='120' prop="year_str" label="年份"
					:show-overflow-tooltip='true'>
				</el-table-column>
				<!-- <el-table-column align='center' min-width='80' prop="permission_name" label="报表申请动作">
				</el-table-column> -->
				<el-table-column align='center' min-width='100' prop="reason" label="申请描述"
					:show-overflow-tooltip='true'>
				</el-table-column>
				<el-table-column align='center' min-width='100' prop="time_str" label="申请时间">
				</el-table-column>
				<el-table-column align='center' min-width='90' label="申请状态">
					<template slot-scope="scope">
						<div :class="{pointer:scope.row.approve_status==11}">
							<span style="margin-right: 2px"
								v-if="scope.row.approve_status!=11">{{ scope.row.approve_status_name }}</span>
							<i class="el-icon-success" v-if="scope.row.approve_status==1"></i>
							<i class="el-icon-question" v-if="scope.row.approve_status==3"></i>
							<el-popover placement="top" width="200" trigger="hover" :content="scope.row.refuse_reason">
								<div v-show="scope.row.approve_status==11" slot="reference">
									<span style="margin-right: 2px">{{ scope.row.approve_status_name }}</span>
									<i class="el-icon-warning"></i>
								</div>

							</el-popover>
						</div>
					</template>
				</el-table-column>
				<el-table-column align='center' min-width='90' label="操作">
					<template slot-scope="scope">
						<div v-if="scope.row.approve_status==1" class="export-div">
							<div class="cm pointer fw" @click='export_file(scope.row)'>{{scope.row.excel_text}}</div>
							<div class="cm pointer fw" v-if="scope.row.file_path_all" 
								@click='export_qusetion(scope.row.file_path_all,scope.row.year_str+"年"+(scope.row.data_type == "village" ? "入村" : "入户")+"问卷")'>下载调查问卷
							</div>
						</div>

						<!-- <div @click="$router.push(`/report?id=${scope.row.id}`)" v-if="scope.row.approve_status==1" class="pointer">测试</div> -->
					</template>
				</el-table-column>
				<div slot="empty" v-show="!loading">
					您还没有可访问的数据权限，去<span class="cm" style="cursor: pointer;" @click="openStandard">申请</span>
				</div>
			</el-table>
			<!-- 分页器pc端 -->
			<div class="u-flex u-row-center">
				<el-pagination class="u-m-t-30 hidden-sm-and-down" background layout="prev, pager, next" :total="total"
					:page-size='pageSize' :current-page='pageNum' @current-change='currentChange'>
				</el-pagination>
			</div>
			<!-- 分页器移动端 -->
			<div class="u-flex u-row-center">
				<el-pagination class="u-m-t-20 hidden-md-and-up" background layout="prev, pager, next" :total="total"
					small :page-size='pageSize' :current-page='pageNum' @current-change='currentChange'>
				</el-pagination>
			</div>
		</div>


		<!-- 权限申请 -->
		<el-dialog :visible.sync="dialogVisible" top='0' :before-close="handleClose" center :show-close='false'
			:close-on-press-escape='false' :close-on-click-modal='false'>
			<!-- :destroy-on-close='true' -->
			<el-form :model="form" :rules="rules" ref="form" label-width="110px" label-position="left" size="mini">
				<el-form-item label="数据类型" prop="data_type">
					<el-select v-model="form.data_type" placeholder="请选择" @change='typeSelectChange'>
						<el-option v-for="item in options_data_type" :key="item.value" :label="item.label"
							:value="item.value">
						</el-option>
					</el-select>
				</el-form-item>
				<el-form-item label="年份" prop="year">
					<el-select v-model="form.year" placeholder="请选择" @change='yearSelectChange' ref="select_year"
						@focus="year_focus">
						<el-option v-for="item in optionsYears_origin" :key="item" :value="item">
						</el-option>
					</el-select>
				</el-form-item>
				<el-form-item label="地区" prop="area">
					<el-cascader v-model="form.area" :options="area_list" :props="props" clearable
						@focus="cascader_focus" @change='cascaderSelectChange' :show-all-levels="false" collapse-tags>
					</el-cascader>
				</el-form-item>
				<el-form-item label="基本信息" prop="info">
					<el-select v-model="form.info" multiple placeholder="请选择" @focus="info_focus"
						@change='infoSelectChange' ref="select_info">
						<el-option v-for="item in optionsInfo" :key="item.second_index_standard"
							:value="item.second_index_standard">
						</el-option>
					</el-select>
				</el-form-item>
				<el-form-item label="研究主题" prop="research_topic">
					<el-select v-model="form.research_topic" placeholder="请选择">
						<el-option v-for="item in research_topic" :key="item.value" :label="item.label"
							:value="item.value">
						</el-option>
					</el-select>
				</el-form-item>
				<!-- <el-form-item label="报表动作" prop="action">
					<el-radio-group v-model="form.action">
						<el-radio :label="4">只查看</el-radio>
						<el-radio :label="2">查看及导出</el-radio>
					</el-radio-group>
				</el-form-item> -->
				<el-form-item label="申请描述" prop="desc">
					<el-input type="textarea" :autosize="{ minRows: 3, maxRows: 5}" placeholder="为了便于审核,请填写使用数据的用途。"
						clearable resize='none' v-model.trim="form.desc" :maxlength="1000" :show-word-limit="true">
					</el-input>
				</el-form-item>
				<el-form-item label="上传数据申请" required>
					<el-upload ref="upload" :limit="1" :action="uploadUrl" :auto-upload="false" :file-list="fileList"
						:before-remove="beforeRemove" :on-preview="handlePreview" :data='uploadData' name='file_data'
						:headers='uploadHeaders' :with-credentials='true' :on-error='uploadErr'
						:on-success='uploadSuccess' :on-change='uploadChange' :on-remove='removeFile'>
						<el-button size="small" type="primary" v-show="!fileList.length"
							style="background-color: #7c2326;">点击上传</el-button>
					</el-upload>
				</el-form-item>
				<div class="dialog-footer">
					<el-button size="mini" @click="resetForm" class="cancle">取 消</el-button>
					<el-button size="mini" @click="checkForm" class="sure" :disabled="is_btn_disabled">确 定</el-button>
				</div>
				<el-form-item prop="checked" label-width="0" class="u-m-t-30" style="margin-bottom: 0;">
					<el-checkbox v-model="form.checked"><span
							style="color: #F56C6C;margin-right: 4px">*</span>勾选即同意<span class="tongyi"
							@click="dialogVisibleRead=true">《数据使用协议》</span></el-checkbox>
				</el-form-item>
			</el-form>
		</el-dialog>
		<!-- 协议 -->
		<el-dialog :visible.sync="dialogVisibleRead" top='0' :show-close='false' :close-on-press-escape='false'
			:close-on-click-modal='false'>
			<div class="my-dialog">
				<div class="c0 edit-back" v-html="user_agreement"></div>
				<div class="u-flex u-row-center u-m-t-30">
					<el-button @click="dialogVisibleRead = false" class="agree-btn">我已知晓</el-button>
				</div>
			</div>
		</el-dialog>
		<!-- 数据使用要求和规范 -->
		<el-dialog :visible.sync="dialogVisibleStandard" top='0' :show-close='false' :close-on-press-escape='false'
			:close-on-click-modal='false'>
			<div class="my-dialog">
				<div class="c0 edit-back" v-html="user_standard"></div>
				<div class="u-flex u-row-center u-m-t-30 my-disabled-wrap">
					<el-button @click="openApplyModal" class="agree-btn" :disabled="is_btn_disabled"
						style="width: 100%;">
						{{apply_text}}
					</el-button>
				</div>
			</div>
		</el-dialog>
		<!-- 下载调查问卷 -->
		<el-dialog :visible.sync="dialogVisibleQuestion" width="50%" top='0'>
			<el-table :data="questionData" style="width: 100%;margin-top: 20px;" border size="mini">
				<el-table-column align="center" prop="year" label="年份" />
				<el-table-column align="center" label="数据类型">
				        <template slot-scope="scope">
				          <span>{{ scope.row.data_type == "village" ? "入村" : "入户" }}</span>
				        </template>
				      </el-table-column>
				<el-table-column align="center" label="调查问卷">
					<template slot-scope="scope">
						<span style="color: #1890ff;" class="poniter" v-if="scope.row.file_path"
							@click='export_qusetion(scope.row.file_path,scope.row.year+"年"+(scope.row.data_type == "village" ? "入村" : "入户")+"问卷")'>下载</span>
					</template>
				</el-table-column>
			</el-table>
		</el-dialog>
	</div>
</template>

<script>
	import {
		getToken
	} from "@/utils/auth";
	export default {
		name: 'Apply',
		components: {},
		data() {
			// 自定义检验规则
			var isCheck = (rule, value, callback) => {
				if (!value) {
					return callback(new Error(''));
				}
				callback();
			};
			return {
				uploadUrl: window.location.origin + '/api/carousel/save-file/',
				uploadData: {
					dir_name: "user_apply_file",
					file_type: "doc",
				},
				fileList: [],
				sys_info: '', //系统描述
				is_btn_disabled: false,
				user_agreement: '',
				user_standard: '',
				province_code: {}, // 所有省对应的code对象
				dialogVisibleRead: false,
				dialogVisibleStandard: false,
				props: {
					multiple: true
				},
				area_list: [],
				area_list2: [],
				form: {
					data_type: '',
					year: '',
					area: [],
					info: '',
					action: 2,
					desc: '',
					research_topic: '',
					checked: false
				},
				rules: {
					data_type: [{
						required: true,
						message: '请选择数据类型',
						trigger: 'blur'
					}],
					year: [{
						required: true,
						message: '请选择报表年份',
						trigger: 'blur'
					}],
					area: [{
						required: true,
						message: '请选择地区维度',
						trigger: 'blur'
					}],
					info: [{
						required: true,
						message: '请选择基本信息维度',
						trigger: 'blur'
					}],
					research_topic: [{
						required: true,
						message: '请选择研究主题',
						trigger: 'blur'
					}],
					action: [{
						required: true,
						message: '请选择报表动作',
						trigger: 'blur'
					}],
					desc: [{
						required: true,
						message: '请输入备注说明',
						trigger: 'blur'
					}],
					checked: [{
						required: true,
						message: '请勾选相关协议',
						trigger: 'blur',
						validator: isCheck
					}],
				},
				dialogVisible: false,
				query: {
					years: [],
					province_codes: [],
					index_2nd: [],
					approve_status: undefined,
				},
				optionsStatus: [{
						value: '3',
						label: '待审批'
					}, {
						value: '1',
						label: '审批通过'
					},
					{
						value: '11',
						label: '审批不通过'
					}
				],
				options_data_type: [{
					value: 'village',
					label: '入村'
				}, {
					value: 'family',
					label: '入户'
				}],
				optionsYears: [], //年份下拉数据
				optionsYears_origin: [], //年份下拉数据源数据 不拼接全部
				optionsYears_origin_village: [], //年份下拉数据源数据:入村 不拼接全部
				optionsYears_origin_family: [], //年份下拉数据源数据:入户 不拼接全部
				optionsInfo: [],
				optionsInfo2: [],
				optionsInfo_origin: [],
				optionsInfo_origin2: [],
				tableData: [],
				province_str: '',
				province_str_family: '',
				info_str: '',
				info_str_family: '',
				year_str: '', //入村年份全部数据字符串,用于比较用户是否选择了全部对应的年份
				year_str_family: '', //入户年份全部数据字符串,用于比较用户是否选择了全部对应的年份
				count_num: 0, // 用于判断异步请求是否都执行完再去做相应用操作
				show_login: false,
				pageNum: 1,
				pageSize: 10,
				total: 0,
				excel_text: '下载excel文件',
				approveFile: "",
				dialogVisibleQuestion: false,
				questionData: [], // 问卷数据
				research_topic: [],
				apply_text: '',
				loading: true
			}
		},
		computed: {


			uploadHeaders() {
				if (getToken()) {
					return {
						"Authorization": "jwt " + getToken(),
					}
				}
				if (this.getCookie_old("csrftoken")) {
					return {
						"X-CSRFToken": this.getCookie_old("csrftoken")
					}
				}
			},
		},
		watch: {
			count_num: {
				handler(newVal, oldVal) {
					if (newVal == 4) {
						this.get_table_data({})
					}
				},
				immediate: true
			}
			// count_num(val) {
			// 	if (val == 2) {
			// 		this.get_table_data({})
			// 	}
			// }
		},
		// activated() {
		// 		if(this.count_num==2){
		// 			this.get_table_data({})
		// 		}
		// },
		async mounted() {
			this.getQuestionList();
			this.$API.getApproveFile().then(res => {
				this.approveFile = res.length ? res[0].file_path : ''
			})
			this.$API.get_topic().then(res => {
				let research_topic = res.data.results.map(item => {
					return {
						value: item.id,
						label: item.name
					}
				})
				this.research_topic = research_topic
			})
			// 查询年列表下拉数据:入村
			const res = await this.$API.queryIndex({
				query_type: "year",
				data_type: "village"
			})
			// 查询年列表下拉数据:入户
			const res_family = await this.$API.queryIndex({
				query_type: "year",
				data_type: "family"
			})
			this.optionsYears_origin_village = res.years.sort()
			this.optionsYears_origin_family = res_family.years.sort()
			// this.optionsYears = ['全部年份', ...res.years.sort()]
			this.year_str = this.optionsYears_origin_village.join('、')
			this.year_str_family = this.optionsYears_origin_family.join('、')
			let year_list = this.optionsYears_origin_village.join(';')
			let year_list_family = this.optionsYears_origin_family.join(';')

			// 查询基本信息维度下拉数据 入村
			this.$API.queryIndex({
				query_type: "index_2nd",
				year_list,
				data_type: "village"
			}).then(res3 => {
				// 判断有无数据  有数据在插全部 没数据返回个 {}
				// if (res3.data) {
				// 	this.optionsInfo2 = [{
				// 		second_index_standard: '全部维度'
				// 	}, ...res3.data]
				// } else {
				// 	this.optionsInfo2 = res3.data
				// }
				// this.optionsInfo_origin2 = res3.data
				// this.optionsInfo_origin2.forEach(item => {
				// 	this.info_str += item.second_index_standard + '、'
				// })
				res3.data.forEach(item => {
					this.info_str += item.second_index_standard + '、'
				})
				this.info_str = this.info_str.substring(0, this.info_str.length - 1)
				this.count_num++
			})
			// 查询基本信息维度下拉数据 入户
			this.$API.queryIndex({
				query_type: "index_2nd",
				year_list: year_list_family,
				data_type: "family"
			}).then(res3 => {
				res3.data.forEach(item => {
					this.info_str_family += item.second_index_standard + '、'
				})
				this.info_str_family = this.info_str_family.substring(0, this.info_str_family.length - 1)
				this.count_num++
			})
			// 获取所有省对应的code
			const province_code = await this.$API.area_code()
			this.province_code = province_code.data
			// 查询地区维度下拉数据 入村
			this.$API.area_group(year_list, "village").then(res2 => {
				res2.forEach(item => {
					// let children = []
					for (let key in item.province_code_list_new) {
						// children.push({
						// 	value: item.province_code_list_new[key],
						// 	label: key,
						// })
						// 记录所有省份组成的字符串 用来判断显示全部
						this.province_str += this.province_code[item] + '、'
					}
					// this.area_list2.push({
					// 	value: item.id,
					// 	label: item.group_name,
					// 	children
					// })
				})
				this.province_str = this.province_str.substring(0, this.province_str.length - 1)
				this.count_num++
			})
			// 查询地区维度下拉数据 入户
			this.$API.area_group(year_list_family, "family").then(res2 => {
				res2.forEach(item => {
					for (let key in item.province_code_list_new) {
						// 记录所有省份组成的字符串 用来判断显示全部
						this.province_str_family += this.province_code[item] + '、'
					}
				})
				this.province_str_family = this.province_str_family.substring(0, this.province_str_family
					.length - 1)
				this.count_num++
			})



			const user_agreement = await this.$API.user_agreement({
				agreement_type: "user"
			})
			this.user_agreement = user_agreement.data.results.length ? user_agreement.data.results[0]
				.user_agreement : ''
			const user_standard = await this.$API.user_agreement({
				agreement_type: "data"
			})
			this.user_standard = user_standard.data.results.length ? user_standard.data.results[0]
				.user_agreement : ''
		},
		methods: {
			openApplyModal() {
				this.dialogVisibleStandard = false;
				this.dialogVisible = true;
			},
			openStandard() {
				this.is_btn_disabled = true
				this.dialogVisibleStandard = true;
				this.apply_text = 15
				let timeId = setInterval(() => {
					this.apply_text--;
					if (this.apply_text == 0) {
						clearInterval(timeId)
						this.apply_text = '申请';
						this.is_btn_disabled = false
					}
				}, 1000)
			},
			checkForm() {
				if (!this.fileList.length) {
					this.$message.error("请先上传数据申请文件")
					return
				}
				this.$refs.form.validate(async (valid) => {
					if (valid) {
						this.submitForm()
					} else {
						return false;
					}
				});
			},
			async getQuestionList() {
				const {
					data: {
						results
					}
				} = await this.$API.getQuestion();
				this.questionData = results;
			},
			getCookie_old(name) {
				var r = document.cookie.match("\\b" + name + "=([^;]*)\\b");
				return r ? r[1] : undefined;
			},
			async uploadSuccess(response) {
				let data = {
					data_type: this.form.data_type,
					year_list: this.get_year_str(),
					province_code_list: this.get_province_str(),
					second_index_list: this.get_info_str(),
					permission: this.form.action,
					reason: this.form.desc,
					reason_file_path: response.data,
					research_topic: this.form.research_topic
				}
				const res = await this.$API.post_approve(data)
				this.is_btn_disabled = false
				this.search()
				this.$message.success('申请成功')
				this.resetForm()
			},
			uploadChange(file, fileList) {
				this.fileList = fileList
			},
			removeFile(file, fileList) {
				this.fileList = []
			},
			uploadErr(err) {
				this.$message.error(JSON.parse(err.message).detail)
				this.is_btn_disabled = false
			},
			beforeRemove(file, fileList) {
				return this.$confirm(`确定移除 ${ file.name }？`);
			},
			handlePreview(file) {
				if (file.url) {
					window.open(file.url)
				}
			},
			getCookie(name) {
				var r = document.cookie.match("\\b" + name + "=([^;]*)\\b");
				return r ? r[1] : undefined;
			},
			async export_file(row) {
				if (row.excel_text == '下载中...') return
				row.excel_text = '下载中...'
				// let params = {
				// 	// year_list: this.params.year_list,
				// 	// second_index_list: this.params.second_index_list,
				// 	// province_code_list: this.params.province_code_list,
				// 	export: true
				// }
				// const res = await this.$API.report_detail(params, row.id)
				// row.excel_text = '下载excel文件'
				// window.open(location.origin + res.data.file_url);
				// window.open("http://10.2.36.97" + res.data.file_url);
				// 目前后台直接返回excel文件
				// window.open(`http://10.2.36.97/api/approve/${row.id}/reports/?export=true`);
				// window.open(`${location.origin}/api/approve/${row.id}/reports/?export=true`);
				this.$API.download_excel(row.id,row.data_type).then(res => {
					const blob = res.data;
					const a = document.createElement("a");
					// 由于后台返回文件名称是通过response返回的
					// 因此需要从response headers中content-disposition响应头中获取文件名称fileName
					const headers = res.headers;
					let fileName = headers["content-disposition"];
					fileName = fileName.split("=")[1];

					// download是a标签的一个属性，可以自定义文件名称
					a.download = decodeURI(fileName.substring(1, fileName.length - 1));

					a.href = URL.createObjectURL(blob);
					document.body.appendChild(a);
					a.click();
					document.body.removeChild(a);
					row.excel_text = '下载excel文件'
				}).catch(err => {
					this.$message.error("下载失败!");
				});
			},
			export_qusetion(file_path, file_name) {
				// window.open(window.location.origin + url);
				this.$API.download_file({
					file_path,
					file_name
				}).then(res => {
					const blob = res.data;
					const a = document.createElement("a");
					// 由于后台返回文件名称是通过response返回的
					// 因此需要从response headers中content-disposition响应头中获取文件名称fileName
					const headers = res.headers;
					let fileName = headers["content-disposition"];
					fileName = fileName.split("=")[1];

					// download是a标签的一个属性，可以自定义文件名称
					a.download = decodeURI(fileName);

					a.href = URL.createObjectURL(blob);
					document.body.appendChild(a);
					a.click();
					document.body.removeChild(a);
				}).catch(err => {
					this.$message.error("下载失败!");
				});
			},
			// 行的 className 的回调方法
			row_class_func(e) {
				// if(e.row.approve_status==1){
				// 	return 'poniter'
				// }
			},
			row_click(row) {
				// if (row.approve_status == 1) {
				// 	localStorage.setItem('title',row.year_str+' - '+row.province_str+' - '+row.info_str+' ' + '统计')
				// 	this.$store.state.permission=row.permission
				// 	sessionStorage.setItem("permission",row.permission)
				// 	this.$router.push({
				// 		path:'/report',
				// 		query:{
				// 			id:row.id
				// 		}
				// 	})
				// } 
			},
			// temp(){
			// 	this.$API.temp({
			// 		approve_status:1,
			// 		reason:'ok'
			// 	})
			// },
			search() {
				// 处理数据
				let years = ''
				if (this.query.years.length) {
					if (this.query.years.includes("全部年份")) {
						// years = this.optionsYears_origin.join(';')
						years = undefined
					} else {
						years = this.query.years.join(';')
					}
				} else {
					years = undefined
				}
				let index_2nd = ''
				if (this.query.index_2nd.length) {
					if (this.query.index_2nd.includes("全部维度")) {
						// let arr = []
						// this.optionsInfo_origin2.forEach(item => {
						// 	arr.push(item.second_index_standard)
						// })
						// index_2nd = arr.join(';')
						index_2nd = undefined
					} else {
						index_2nd = this.query.index_2nd.join(';')
					}
				} else {
					index_2nd = undefined
				}
				let province_codes = ''
				if (this.query.province_codes.length) {
					this.query.province_codes.forEach((item, i) => {
						if (i == this.query.province_codes.length - 1) {
							province_codes += item[1]
						} else {
							province_codes += item[1] + ';'
						}
					})
				} else {
					province_codes = undefined
				}
				this.pageNum = 1
				this.get_table_data({
					year_list: years,
					second_index_list: index_2nd,
					province_code_list: province_codes,
					approve_status: this.query.approve_status ? this.query.approve_status : undefined
				})
			},
			// 页数改变
			currentChange(current) {
				this.pageNum = current
				this.get_table_data({})
			},
			// 授权申请列表
			get_table_data(params) {
				params.pageSize = this.pageSize
				params.pageNum = this.pageNum
				this.$API.get_approve_list(params).then(res => {
					res.data.results.forEach(item => {
						let province_str = ''
						let info_str = ''
						let year_str = ''
						item.province_codes.forEach((key, i) => {
							if (i == item.province_codes.length - 1) {
								province_str += this.province_code[key]
							} else {
								province_str += this.province_code[key] + '、'
							}
						})
						item.index_2nd.forEach((val, i) => {
							if (i == item.index_2nd.length - 1) {
								info_str += val
							} else {
								info_str += val + '、'
							}
						})
						year_str = item.years.sort().join('、')
						if (item.data_type == 'village' && province_str.length == this.province_str.length ||
							item.data_type == 'family' && province_str.length == this.province_str_family.length) {
							province_str = '全部省份'
						}
						if (item.data_type == 'village' && info_str.length == this.info_str.length ||
							item.data_type == 'family' && info_str.length == this.info_str_family.length
						) {
							info_str = '全部基本信息维度'
						}
						// if (item.data_type == 'village' && year_str.length == this.year_str.length ||
						// 	item.data_type == 'family' && year_str.length == this.year_str_family.length
						// ) {
						// 	year_str = '全部年份'
						// }
						item.province_str = province_str
						item.info_str = info_str
						item.year_str = year_str
						item.time_str = this.moment(item.created_at).format('YYYY-MM-DD')
					})
					res.data.results.forEach(item => {
						item.excel_text = '下载excel文件'
					})
					this.tableData = res.data.results
					this.total = res.data.count
					this.loading = false
				})
			},
			async cascader_focus() {
				this.area_list = []
				// if (!this.form.year.length) {
				// 	this.$message.error('请先选择年份')
				// 	return
				// }
				if (!this.form.year) {
					this.$message.error('请先选择年份')
					return
				}
				let year_list = this.get_year_str()
				// 查询地区维度下拉数据
				let res = await this.$API.area_group(year_list,this.form.data_type)
				// 全部地区先不做了 麻烦
				// this.area_list.push({
				// 	value: -1,
				// 	label: '全部地区',
				// 	children:[
				// 		{
				// 			value: -1,
				// 			label: '全部地区'
				// 		}
				// 	]
				// })
				res.forEach(item => {
					let children = []
					for (let key in item.province_code_list_new) {
						children.push({
							value: item.province_code_list_new[key],
							label: key,
						})
					}
					this.area_list.push({
						value: item.id,
						label: item.group_name,
						children
					})
				})
			},
			async info_focus() {
				this.optionsInfo = []
				this.optionsInfo_origin = []
				if (!this.form.year.length) {
					this.$message.error('请先选择年份')
					return
				}
				let year_list = this.get_year_str()
				let province_code_list = this.get_province_str() ? this.get_province_str() : undefined
				// 查询基本信息维度下拉数据
				let res = await this.$API.queryIndex({
					query_type: "index_2nd",
					year_list,
					province_code_list,
					data_type : this.form.data_type
				})
				// 判断有无数据  有数据在插全部 没数据返回个 {}
				if (res.data) {
					this.optionsInfo = [{
						second_index_standard: '全部维度'
					}, ...res.data]
				} else {
					this.optionsInfo = res.data
				}
				this.optionsInfo_origin = res.data
			},
			async year_focus() {
				if (!this.form.data_type) {
					this.$message.error('请先选择数据类型')
					return
				}
				if (this.form.data_type == 'village') {
					this.optionsYears_origin = this.optionsYears_origin_village
				} else {
					this.optionsYears_origin = this.optionsYears_origin_family
				}
			},
			// 获取当前所选年份字符串
			get_year_str() {
				// if (this.form.year.includes("全部年份")) {
				// 	return this.optionsYears_origin.join(';')
				// } else {
				// 	return this.form.year.join(';')
				// }
				return this.form.year
			},
			// 获取当前所选地区维度字符串  先不考虑全选
			get_province_str() {
				let arr = []
				this.form.area.forEach((item, i) => {
					if (arr.indexOf(item[1]) == -1) {
						arr.push(item[1])
					}
				})
				return arr.join(';')
			},
			// 获取当前所选基本信息维度字符串
			get_info_str() {
				if (this.form.info.includes("全部维度")) {
					let arr = []
					this.optionsInfo_origin.forEach(item => {
						arr.push(item.second_index_standard)
					})
					return arr.join(';')
				} else {
					return this.form.info.join(';')
				}
			},
			yearSelectChange(val) {
				this.form.area = []
				this.form.info = []
				// if (val.includes("全部年份")) {
				// 	this.$refs.select_year.blur()
				// 	this.form.year = ["全部年份"]
				// }
			},
			typeSelectChange(val) {
				this.form.year = ""
				this.form.area = []
				this.form.info = []
			},
			yearSelectChange2(val) {
				if (val.includes("全部年份")) {
					this.$refs.select_year2.blur()
					this.query.years = ["全部年份"]
				}
			},
			cascaderSelectChange() {
				this.form.info = []
			},
			infoSelectChange(val) {
				if (val.includes("全部维度")) {
					this.$refs.select_info.blur()
					this.form.info = ["全部维度"]
				}
			},
			infoSelectChange2(val) {
				if (val.includes("全部维度")) {
					this.$refs.select_info2.blur()
					this.query.index_2nd = ["全部维度"]
				}
			},
			submitForm() {
				this.is_btn_disabled = true
				this.$refs.upload.submit()
			},
			resetForm() {
				setTimeout(() => {
					this.fileList = []
				}, 500)
				this.dialogVisible = false
				this.dialogVisibleStandard = false
				this.$refs.form.resetFields();
			},
			goOrShow(row) {
				if (row.approve_status == 11) {
					this.$confirm(row.refuse_reason, '审批不通过原因', {
						center: true,
						// confirmButtonClass: 'confirm-button',
						showConfirmButton: false,
						showCancelButton: false,
						showClose: false
					})
				}
			},
			// before-close 仅当用户通过点击关闭图标或遮罩关闭 Dialog 时起效
			handleClose(done) {
				done();
			},
			go_login(type) {
				if (type == 1) {
					this.$router.push('/login')
				} else {
					location.href = window.location.origin + "/login-in-school/"
				}
			}
		},
	}
</script>

<style lang="less" scoped>
	.my-disabled-wrap {
		.el-button.is-disabled {
			background-color: #C0C4CC !important;
			color: #FFF;
		}
	}

	.my-dialog {
		height: 74vh;
		overflow: auto;
	}

	.export-div {
		div {
			border-bottom: 2px solid transparent;

			&:hover {
				border-bottom: 2px solid #7c2326;
			}
		}
	}

	.no-login-wrap {
		// font-size: 14PX;
		color: #333333;
		font-weight: 700;
		margin-left: 200px;
		display: flex;

		.sys-desc {
			width: 600px;
			margin-right: 20px;
			margin-top: 50px;
		}

		.login-right {
			flex: 1;
			display: flex;
			flex-direction: column;
			align-items: flex-end;
			margin-top: 14px;
		}

		.login-type {

			// margin: 44PX 0 24PX;
			div:last-child {
				background-color: #f6ad3c;
			}

			div:first-child {
				background-color: #7c2326;
				margin: 20px 0;

			}



			div {
				padding: 0;
				cursor: pointer;
				border-radius: 4px;
				box-sizing: border-box;
				width: 180px;
				height: 46px;

				img {
					width: 28px;
					height: 28px;
					margin-right: 14px;
				}

				span {
					color: #ffffff;
					font-size: 16PX;
				}
			}
		}
	}

	.content-wrap {
		width: 100%;
		margin: 0 auto;
		max-width: 1000PX;
		// padding: 0 12PX;
		box-sizing: border-box;

		.search-wrap {
			span {
				// width: 72PX;
				font-size: 14PX;
			}

			/deep/ .el-select__tags-text {
				font-size: 12PX;
			}
		}

		.el-button {
			width: 80px;
			min-width: 50PX;
			color: #fff;
			// font-size: 8PX !important;
		}

		.bg1 {
			background-color: #b81c22;
			width: 100px;
			min-width: 70PX;
		}

		.bg2 {
			background-color: #f6ad3c;
			width: 100px;
			min-width: 70PX;
		}

		.pointer {
			cursor: pointer;
		}
	}

	/deep/ .el-dialog__header {
		padding: 0 !important;
	}

	/deep/ .el-dialog {
		width: 90% !important;
		max-width: 540PX !important;
		position: absolute;
		top: 50%;
		left: 50%;
		transform: translate(-50%, -50%);
	}


	.el-form-item {
		margin-bottom: 16px;

		/deep/ .el-form-item__label {
			color: #333333 !important;
		}

		.el-select,
		.el-cascader {
			width: 100%;
		}

	}

	.dialog-footer {
		display: flex;
		justify-content: center;
		margin-top: 40px;

		.cancle {
			border: 1px solid #7c2326;
			color: #7c2326;
			font-weight: 700;
			width: 86px;
			min-width: 72PX;
			margin-right: 140px;
			background-color: #fff;
		}

		.sure {
			background-color: #7c2326;
			color: #fff;
			width: 86px;
			min-width: 72PX;
		}
	}

	.tongyi {
		font-size: 14PX;
		color: #7c2326;
		font-weight: 700;
	}

	.agree-btn {
		width: 354px;
		min-width: 160PX;
		background-color: #7c2326;
		color: #fff;
	}

	.agree-btn:hover {
		background-color: #7c2326;
		color: #fff;
	}

	/deep/ .el-pagination.is-background .el-pager li:not(.disabled).active {
		background-color: #7c2326;
		color: #FFF;
	}

	/deep/ .el-pagination.is-background .el-pager li:not(.disabled):hover {
		color: #fff;
	}

	/deep/ .el-pagination.is-background .el-pager li {

		background-color: rgba(124, 35, 38, .1);
	}
</style>
